export const sideNavigationType = {
  LEFT: 'LEFT',
  RIGHT: 'RIGHT',
};
